import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';
import { DealType } from 'components/common/types/Deal.types';
import { getIsReseller } from 'store/publisher/selectors';
import { getCampaignType } from './getCampaignType';
import { getDealType } from './getDealType';

export type CampaignVariant = 'PG' | 'NG' | 'RESELLER' | 'VIOOH_SELECT' | 'DSM';

export const getCampaignVariant = createSelector(
  getCampaignType,
  getIsReseller,
  getDealType,
  (state: Store) => state.reseller.isInternalPublisher,
  ({ isDirectSalesCampaignType }, isReseller, dealType, isInternalPublisher): CampaignVariant => {
    if (isDirectSalesCampaignType) return 'DSM';
    if (isInternalPublisher) return 'VIOOH_SELECT';
    if (isReseller) return 'RESELLER';
    if (dealType === DealType.GUARANTEED) return 'PG';
    return 'NG';
  },
);
